import React from "react"
import Region from "../../ui/Region"
import PageLayout from "./PageLayout"

const HomeLayout = ({ entity, language }) => <Region entity={entity} language={language} dynamic />
export const DefaultLayout = HomeLayout

const nodeLayout = {
    homepage: HomeLayout,
    page: PageLayout,
    NotFound: PageLayout,
}
export default nodeLayout
